import { memo } from "react";
import { Outlet } from "react-router-dom";

import CenterContentPageHolder from "../../components/structure/CenterContentPageHolder";

function AuthRoot() {
   return (
      <CenterContentPageHolder withDecoration>
         <Outlet />
      </CenterContentPageHolder>
   );
}

export default memo(AuthRoot);
